export const IntegrationErrorsActionTypes = {
    API_RESPONSE_SUCCESS: '@@integration-errors/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@integration-errors/API_RESPONSE_ERROR',
    GET_ALL_INTEGRATION_ERRORS: '@@integration-errors/GET_ALL_INTEGRATION_ERRORS',
    RESET_STATE: '@@integration-errors/RESET_STATE',
    RESET_ALL_ERRORS: '@@integration-errors/RESET_ALL_ERRORS',
};
